"use client";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Menggunakan Link untuk navigasi

function SearchBox() {
  const [jobTitle, setJobTitle] = useState(""); // Menyimpan input judul pekerjaan
  const [location, setLocation] = useState(""); // Menyimpan input lokasi
  const [locations, setLocations] = useState([]); // Menyimpan daftar lokasi unik
  const [showLocations, setShowLocations] = useState(false); // Menyembunyikan dan menampilkan dropdown lokasi

  // Mengambil nilai lokasi unik dari API
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await fetch("https://final-project-api-alpha.vercel.app/api/jobs");
        const data = await response.json();
        const cities = [...new Set(data.map((job) => job.company_city))]; // Mengambil lokasi unik
        setLocations(cities);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchLocations();
  }, []);

  return (
    <div className="mt-6 relative z-10">
      <div className="flex p-4 bg-white shadow-2xl max-sm:flex-col max-sm:gap-4">
        <div className="flex flex-1 items-center px-4 py-0 border-r border-solid border-r-zinc-200 max-sm:pb-4 max-sm:border-b max-sm:border-solid max-sm:border-b-zinc-200 max-sm:border-r-[none]">
          <div className="mr-4">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11.7666"
                cy="11.8494"
                r="8.98856"
                stroke="#25324B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></circle>
              <path
                d="M18.0183 18.5679L21.5423 22.0827"
                stroke="#25324B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </div>
          <div className="flex flex-col">
            <input
              type="text"
              placeholder="Job title or keyword"
              className="w-full text-base border-[none] py-2 text-slate-500 border-b-2 border-solid border-b-zinc-200 focus:outline-none focus:border-b-zinc-300"
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
            />
          </div>
        </div>

        <div className="flex flex-1 items-center px-4 py-0 border-r border-solid border-r-zinc-200 max-sm:pb-4 max-sm:border-b max-sm:border-solid max-sm:border-b-zinc-200 max-sm:border-r-[none]">
          <div className="mr-4">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 10.5835C15 9.20224 13.8808 8.08301 12.5005 8.08301C11.1192 8.08301 10 9.20224 10 10.5835C10 11.9638 11.1192 13.083 12.5005 13.083C13.8808 13.083 15 11.9638 15 10.5835Z"
                stroke="#25324B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4995 21.083C11.301 21.083 5 15.9814 5 10.6463C5 6.46964 8.3571 3.08301 12.4995 3.08301C16.6419 3.08301 20 6.46964 20 10.6463C20 15.9814 13.698 21.083 12.4995 21.083Z"
                stroke="#25324B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </div>

          <div className="flex flex-col w-full">
            <div
              className="cursor-pointer text-base text-slate-800 pb-0" 
              onClick={() => setShowLocations(!showLocations)}
            >
              {location || "Select Location"}
            </div>

            {showLocations && (
              <div className="absolute bg-white shadow-lg border border-gray-300 w-64 mt-1 rounded-lg z-10 max-h-full overflow-auto">
                {locations.map((city, index) => (
                  <div
                    key={index}
                    className="p-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      setLocation(city);
                      setShowLocations(false);
                    }}
                  >
                    {city}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <Link
          to={`/vacancies?title=${jobTitle}&location=${location}`}
          className="ml-auto px-7 py-3.5 text-lg font-bold text-white whitespace-nowrap bg-indigo-600 cursor-pointer border-[none] hover:bg-indigo-700 max-sm:w-full max-sm:text-center"
        >
          Search my job
        </Link>
      </div>

      <div className="mt-4 text-base text-gray-800 opacity-70">
        <span>Popular : </span>
        <span>UI Designer, UX Researcher, Android, Admin</span>
      </div>
    </div>
  );
}

export default SearchBox;
